import { FC } from "react";

import Skeleton from "./../../../../libs/Skeleton";

import styles from "./styles.module.scss";

const EditModeSideBarLoading: FC = () => (
    <div>
        <Skeleton width="calc(100% - 64px)" height="28px" margin="36px 32px" />

        <div className={styles.line} />

        <Skeleton width="calc(100% - 64px)" height="58px" margin="32px 32px" />
        <Skeleton width="calc(100% - 64px)" height="58px" margin="32px 32px" />
        <Skeleton width="calc(100% - 64px)" height="58px" margin="32px 32px" />
        <Skeleton width="calc(100% - 64px)" height="58px" margin="32px 32px" />
        <Skeleton width="calc(100% - 64px)" height="58px" margin="32px 32px" />
    </div>
);

export default EditModeSideBarLoading;
